import getProject from "./projects";

const mutationTypes = {
  SET_UTILS: "stakingUtils/SET_UTILS",
};

const state = {
  utils: null,
};

const actions = {
  setProjectUtils({ commit }, projectName) {
    const projectUtils = getProject(projectName);
    commit(mutationTypes.SET_UTILS, projectUtils);
  },
};

const mutations = {
  [mutationTypes.SET_UTILS](state, utils) {
    state.utils = utils;
  },
};

const getters = {
  utils: (state) => state.utils,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
